export const PLAN_ID_LENGTH = 10;
